import { render, staticRenderFns } from "./WDLeadsStatusBadge.vue?vue&type=template&id=506b27d0&"
import script from "./WDLeadsStatusBadge.vue?vue&type=script&lang=js&"
export * from "./WDLeadsStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports